import type { ComponentType } from "react";
import type { AnimationType } from "@/components/Section/Section";
import type { PatternType, SectionBackground, SectionPaddingSize } from "@/types/styling";

export interface ComponentRef {
  $ref: string;
  variant?: string;
  props?: Record<string, unknown>;
}

// biome-ignore lint/suspicious/noExplicitAny: registry accepts components with any prop shapes
export type SectionComponent = ComponentType<any>;

export interface SectionConfig {
  type: string;
  id?: string;
  role?: string;
  className?: string;
  padding?: SectionPaddingSize;
  background?: SectionBackground;
  pattern?: PatternType;
  animate?: AnimationType;
  props: Record<string, unknown>;
}

export function isComponentRef(section: unknown): section is ComponentRef {
  return section !== null && typeof section === "object" && "$ref" in section;
}
